const maxSize = 1024 * 1024 * 12;

export enum UploadValidationError {
  INVALID_TYPE = "invalid_type",
  TOO_LARGE = "too_large",
  CORRUPTED = "corrupted",
};

export type UploadValidationResult = {
  valid: boolean;
  error?: UploadValidationError
}

export function useUploadValidation() {
  const validateFile = (file: File): UploadValidationResult => {
    if (file.type != "image/jpeg" && file.type != "image/png") {
      return {
        valid: false,
        error: UploadValidationError.INVALID_TYPE,
      };
    }

    if (file.size === 0) {
      return {
        valid: false,
        error: UploadValidationError.CORRUPTED,
      };
    }

    if (file.size > maxSize) {
      return {
        valid: false,
        error: UploadValidationError.TOO_LARGE,
      }
    }

    return {
      valid: true,
    };
  };

  return {
    validateFile,
  }
}
